import "./style.less";

export default function bookingCompletedAddons() {
    return {
        restrict: "E",
        scope: {
            bpe: "=",
            isCollapsed: "=",
        },

        template: require("./template.html"),

        controller: function ($scope, $timeout) {
            $scope.clickcount = 0;

            $scope.clickDelayedCalcPrice = function (addOnService, amount) {
                $scope.clickcount++;

                addOnService.Count += amount;

                if ($scope.clickcount == 1) {
                    $timeout(function () {
                        $scope.calcPrice(addOnService, amount);

                        $scope.clickcount = 0;
                    }, 600);
                }
            };

            $scope.calcPrice = function (addOnService) {
                // avail params :: addOnService, amount
                //if ( !(addOnService.Count === 0 && amount === -1) ) {
                // Bookings
                //     .getReCalculateAdditionalServices(addOnService)
                //     .then(function(reCalAdditionalServices) {
                //         addOnService.UnitPrice =
                //             reCalAdditionalServices.UnitPrice;
                //         addOnService.SumPice =
                //             addOnService.UnitPrice * addOnService.Count;
                //         $rootScope.$broadcast("booking-update-broadcast");
                //     });
                //}
            };
        },
    };
}
